import { render, staticRenderFns } from "./RatioCalculatorInsurer.vue?vue&type=template&id=c05eef52&scoped=true"
import script from "./RatioCalculatorInsurer.vue?vue&type=script&lang=js"
export * from "./RatioCalculatorInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05eef52",
  null
  
)

export default component.exports